// 区間が現地用かどうか
export const checkIsLocalUse = (price) => {
  return price.from_station && price.from_station.code == -1;
};
